import { render, staticRenderFns } from "./professorForm.vue?vue&type=template&id=7d98061a&scoped=true"
import script from "./professorForm.vue?vue&type=script&lang=js"
export * from "./professorForm.vue?vue&type=script&lang=js"
import style0 from "./professorForm.vue?vue&type=style&index=0&id=7d98061a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98061a",
  null
  
)

export default component.exports